module.exports = __webpack_public_path__ + "static/Lamentum7-227bb67deed1fa7b07c46c2fb696ff1d.webp";